export const AUTOCOMPLETE_PAGESIZE: number = 20
